import {
    LIST_ORGANIZATIONS_SUCCESS, OPEN_UPDATE_DIALOG, OPEN_CREATE_DIALOG, OPEN_DELETE_DIALOG, CLOSE_DIALOGS, CREATE_ORGANIZATION_SUCCESS,
    CREATE_ORGANIZATION_FAILURE, UPDATE_ORGANIZATION_SUCCESS, UPDATE_ORGANIZATION_FAILURE, DELETE_ORGANIZATION_FAILURE, DELETE_ORGANIZATION_SUCCESS,
} from './OrganizationsActionTypes'

export const initialOrganizationsState = () => ({
    organizationList: null,
    organizationName: null,
    organizationId: null,
    contactName: null,
    contactPhone: null,
    createDialogOpen: false,
    updateDialogOpen: false,
    deleteDialogOpen: false,
    saveOrganizationError: null,
});

const organizations = (state = initialOrganizationsState(), action) => {
    switch (action.type) {
        case LIST_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                organizationList: action.organizations,
                organizationName: null,
            }
        case OPEN_CREATE_DIALOG:
            return {
                ...state,
                createDialogOpen: true,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                organizationName: null,
            }
        case OPEN_UPDATE_DIALOG:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: true,
                deleteDialogOpen: false,
                organizationId: action.organizationId,
                organizationName: action.organizationName,
                contactName: action.contactName,
                contactPhone: action.contactPhone,
            }
        case OPEN_DELETE_DIALOG:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                deleteDialogOpen: true,
                organizationId: action.organizationId,
                organizationName: action.organizationName,
            }
        case CLOSE_DIALOGS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                saveOrganizationError: null,
                organizationId: null,
                organizationName: null,
                contactName: null,
                contactPhone: null,
            }
        case CREATE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                createDialogOpen: false,
                saveOrganizationError: null,
            }
        case CREATE_ORGANIZATION_FAILURE:
            return {
                ...state,
                createDialogOpen: true,
                saveOrganizationError: "Error while trying to create organization"
            }
        case UPDATE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                updateDialogOpen: false,
                saveOrganizationError: null,
            }
        case UPDATE_ORGANIZATION_FAILURE:
            return {
                ...state,
                updateDialogOpen: true,
                saveOrganizationError: "Error while trying to update organization",
            }
        case DELETE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                deleteDialogOpen: false,
                saveOrganizationError: null,
            }
        case DELETE_ORGANIZATION_FAILURE:
            return {
                ...state,
                deleteDialogOpen: true,
                saveOrganizationError: "Error while trying to delete organization",
            }
        default:
            return state;
    }
}
export default organizations;